import { api } from './_request';

export const enviar_factura = (correos, callback) => {
	
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });
  		console.log('correos--->',correos);
		api().post('/correo_factura', correos).then(function(response) {

			if(response.status === 200) {
				dispatch({ type: 'TICKET_UPDATE_SUCCESS' });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'TICKET_UPDATE_FAILURE' });
			}
		})
		.catch(function(error) {
			console.log('error-->',error);
			dispatch({ type: 'TICKET_UPDATE_FAILURE' });
		});

	}
};

export const get_tickets = () => {
	return (dispatch) => {

		api().get('/ticketsv2').then(function(response) {
			if(response.status === 200) {
				dispatch({
					type: 'TICKET_LIST',
					payload: response.data
				});
			}
		});
	}
};

 export const get = (data) => {
 	return (dispatch) => {

 		
				dispatch({
				type: 'TICKET_LIST',
					payload: data
 				});
			 		

 	}
 };
export const get_tickets_insidencias = (id) => {
	return (dispatch) => {

		api().get('/ticketsv2/insidencias/'+id).then(function(response) {
			if(response.status === 200) {
				dispatch({
					type: 'TICKET_LIST_INSIDENCIAS',
					payload: response.data
				});
			}
		});
	}
};

export const get_llamadas = (id) => {
	return (dispatch) => {

		api().get('/llamarcliente/'+id).then(function(response) {
			if(response.status === 200) {
				dispatch({
					type: 'LLAMADAS_LIST',
					payload: response.data
				});
			}
		});



	}
};

export const save_ticket = (ticket, callback) => {
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });

		api().post('ticketsv2', ticket).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'TICKET_SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'TICKET_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_SAVE_FAILURE' });
		});

	}
};

export const save_llamada = (llamada, callback) => {
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });

		api().post(`/llamarcliente`, llamada).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'LLAMADA_SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data.id);

			}
			else{
				dispatch({ type: 'TICKET_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_SAVE_FAILURE' });
		});

	}
};

export const update_ticket = (ticket, callback) => {
	
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });

		api().post('ticketsv2/'+ticket.id, ticket).then(function(response) {

			if(response.status === 200) {
				dispatch({ type: 'TICKET_UPDATE_SUCCESS' });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'TICKET_UPDATE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_UPDATE_FAILURE' });
		});

	}
};

export const update_estado = (ticket, callback) => {
	return (dispatch) => {

		dispatch({ type: 'TICKET_UPDATE' });

		api().post('ticketsv2/estado/'+ticket.id, ticket).then(function(response) {

			if(response.status === 200) {
				dispatch({ type: 'TICKET_UPDATE_SUCCESS' });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'TICKET_UPDATE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_UPDATE_FAILURE' });
		});

	}
};

export const pagar = (ticket, callback) => {
	return (dispatch) => {

		dispatch({ type: 'TICKET_UPDATE' });

		api().post('ticketsv2/pagar/'+ticket.id, ticket).then(function(response) {

		//	console.log(response);

		//	console.log(response.status === 200);

			if(response.status === 200) {

				dispatch({ type: 'TICKET_UPDATE_SUCCESS' });

				if(typeof callback === 'function')
					callback(response.data);

			//	console.log('asdasdasd')

			}
			else {
				dispatch({ type: 'TICKET_UPDATE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_UPDATE_FAILURE' });
		});

	}
};


export const pagar_credito = (ticket, callback) => {
	
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });

		api().post('ticketsv2/full_update/'+ticket.id, ticket).then(function(response) {

			if(response.status === 200) {
				dispatch({ type: 'TICKET_UPDATE_SUCCESS' });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'TICKET_UPDATE_FAILURE' });
			}

		})
		.catch(function(error) {
			console.log('error-->',error);
			dispatch({ type: 'TICKET_UPDATE_FAILURE' });
		});

	}
};

export const save_compra = (compra, callback) => {
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });

		api().post('compra_especial', compra).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'TICKET_UPDATE_FAILURE',
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'TICKET_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_SAVE_FAILURE' });
		});

	}
};


export const alerta = (alerta) => {
		return (dispatch) => {
			dispatch({
						type: 'SAVE_ALERTA',
						payload: alerta
					});
		}
	};




// WEBPACK FOOTER //
// ./src/actions/ticket.js